import _each from 'lodash/each';
import _forOwn from 'lodash/forOwn';
import _isArray from 'lodash/isArray';
import {DateTime} from 'luxon';
import {ParamsObj} from './apiTypes';

function createParamObjWithMultiples(paramsObj: ParamsObj) {
  const newParams = new URLSearchParams();

  _forOwn(paramsObj, (value, key) => {
    if (_isArray(value)) {
      _each(value, (el) => {
        newParams.append(key, `${el}`);
      });
    } else {
      newParams.append(key, `${value}`);
    }
  });

  return newParams;
}

function formatDateTimeQueryParam(datetime: DateTime) {
  return datetime.toISO();
}

async function getFileContentAsBlob(file: File) {
  const buffer = await file.arrayBuffer();

  return new Blob([new Uint8Array(buffer)], {type: file.type});
}

export {createParamObjWithMultiples, getFileContentAsBlob, formatDateTimeQueryParam};
